<template>
    <div>
        <div id="mainhold">
            <div id="leftcol" class="cols">
                <div v-for="(list, index) in ldoc" v-bind:key='index'>
                    <div class="listingholder">
                        <div class="imgHolder" :style="{ 'background-image': `url(${list.mainURL})`}"></div>
                        <div class="wrapper amTealregular">{{list.artmarketID}}</div>
                        <!-- <div class="wrapper amTealregular" v-if="list.status">Pending</div>
                        <div class="wrapper amTealregular" v-if="!list.status">Processed</div> -->
                        <div class="btn bgTeal cpointer" @click="openListing(list)">open</div>
                    </div>
                </div>
            </div>
            <!-- <div class="padma"></div> -->
            <div id="rightcol">
                <div class="wrapperr amTealregular">amID: {{olist.artmarketID}}</div>
                <div class="wrapperr amGrayregular">by: {{olist.fullname}}</div>
                <div class="wrapperr amGrayregular">listed: {{olist.post_date | moment('from', 'now')}}</div>
                <div class="imgHolder2" :style="{ 'background-image': `url(${olist.mainURL})`}" @click="openImage(olist.mainURL)"></div>
                <div class="buttonHolder">
                    <div class="btn2 bgMint cpointer" @click="viewPost(olist.document_Id)">View Post</div>
                    <div class="btn2 bgTeal cpointer" @click="openLabel(olist.shippingLabel)">PRINT LABEL</div>
                    <div class="btn2 bgPink cpointer" @click="cfront(olist)">Certificate</div>
                    </div>
                <div class="wrapperr amGrayregular">{{olist.height}}h x {{olist.width}}w x {{olist.depth}}d {{olist.unit}} | wGlove: {{olist.white_glove}}</div>
                <div class="wrapperr amGrayregular">Room: {{olist.selectIMG}}</div>
                <div class="wrapperr amGrayregular">LISTID: {{olist.listID}}</div>
                <div class="wrapperr amTealregular">NFC CODE | {{olist.nfcID}}</div>
                <div class="spacer"></div>
                <div class="holder amTealregular textleft" v-if="!isUploaded">Add Accent Images<br>
                    <div class="amGrayregular text">IMG <input type="file" ref="fileInput"><br> WIDE <input type="file" ref="fileInput2"></div>
                    <div class="spacer"></div>
                    <div class="btn2 bgGray cpointer" @click="uploadPics(olist)">Upload</div>
                </div>
                <div v-if="!isEdited">
                <div class="holder">
                    <div id="black" v-if="!sblack" class="colorBox" :style="{'background-image':'url(' + require('@/assets/images/cf_black.svg')+')'}" @click="addColor('black')"></div>
                    <div id="black" v-if="sblack" class="selectedColor" :style="{'background-image':'url(' + require('@/assets/images/cf_black.svg')+')'}" ></div>
                    <div id="white" v-if="!swhite" class="colorBox" :style="{'background-image':'url(' + require('@/assets/images/cf_white.svg')+')'}" @click="addColor('white')"></div>
                    <div id="white" v-if="swhite" class="selectedColor" :style="{'background-image':'url(' + require('@/assets/images/cf_white.svg')+')'}" ></div>
                    <div id="brown" v-if="!sbrown" class="colorBox" :style="{'background-image':'url(' + require('@/assets/images/cf_brown.svg')+')'}" @click="addColor('brown')"></div>
                    <div id="brown" v-if="sbrown" class="selectedColor" :style="{'background-image':'url(' + require('@/assets/images/cf_brown.svg')+')'}" ></div>
                    <div id="blue" v-if="!sblue" class="colorBox" :style="{'background-image':'url(' + require('@/assets/images/cf_blue.svg')+')'}" @click="addColor('blue')"></div>
                    <div id="blue" v-if="sblue" class="selectedColor" :style="{'background-image':'url(' + require('@/assets/images/cf_blue.svg')+')'}"></div>
                    <div id="green" v-if="!sgreen" class="colorBox" :style="{'background-image':'url(' + require('@/assets/images/cf_green.svg')+')'}" @click="addColor('green')"></div>
                    <div id="green" v-if="sgreen" class="selectedColor" :style="{'background-image':'url(' + require('@/assets/images/cf_green.svg')+')'}"></div>
                    <div id="yellow" v-if="!syellow" class="colorBox" :style="{'background-image':'url(' + require('@/assets/images/cf_yellow.svg')+')'}" @click="addColor('yellow')"></div>
                    <div id="yellow" v-if="syellow" class="selectedColor" :style="{'background-image':'url(' + require('@/assets/images/cf_yellow.svg')+')'}"></div>
                    <div id="red" v-if="!sred" class="colorBox" :style="{'background-image':'url(' + require('@/assets/images/cf_red.svg')+')'}" @click="addColor('red')"></div>
                    <div id="red" v-if="sred" class="selectedColor" :style="{'background-image':'url(' + require('@/assets/images/cf_red.svg')+')'}"></div>
                    <div id="orange" v-if="!sorange" class="colorBox" :style="{'background-image':'url(' + require('@/assets/images/cf_orange.svg')+')'}" @click="addColor('orange')"></div>
                    <div id="orange" v-if="sorange" class="selectedColor" :style="{'background-image':'url(' + require('@/assets/images/cf_orange.svg')+')'}"></div>
                    <div id="rainbow" v-if="!srainbow" class="colorBox" :style="{'background-image':'url(' + require('@/assets/images/cf_rainbow.svg')+')'}" @click="addColor('rainbow')"></div>
                    <div id="rainbow" v-if="srainbow" class="selectedColor" :style="{'background-image':'url(' + require('@/assets/images/cf_rainbow.svg')+')'}"></div>
                    </div>
                    <div class="spacer"></div>
                    <div class="holder">
                <div class="inputbar amGrayregular textleft">MC Earnable % <input type="text" v-model="earnPercentage"></div>
                <div class="inputbar amGrayregular textleft">CRate % <input type="text" v-model="commissionRate"></div>
                <div class="inputbar amGrayregular textleft">CRate Expires <datepicker name="expireDate" v-model="dateSelect.date"></datepicker></div>
                <div class="spacer"></div>
                <div class="btn2 bgMint cpointer" @click="completeDetails(olist)">Submit Details</div>
                    </div>
                </div>
                <div class="spacer"></div>
                <div class="spacer"></div>
                <div class="wrapperr">
                <!-- <div class="btn bgPink cpointer" @click="processed(olist.listID, olist)">Mark as Done</div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import firebase from 'firebase/app';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import { resizeImage } from "../utils";
import 'firebase/functions'
import 'firebase/auth'
import 'firebase/firestore'
import db from '../main'
import _ from 'lodash'
export default {
    name: "listings",
    data(){
        return {
            requested: "",
            ldoc : [],
            sortdoc: [],
            olist : {},
            isUploaded: false,
            accentBlob: "",
            accentBlobW: "",
            fsaccent: "",
            fsaccentW: "",
            uploadValue: "",
            commissionRate: "",
            cRateDate: "",
            earnPercentage: "",
            colorfamily: [],
            isEdited: false,
            dateSelect: new Date(),
            sblack: false,
            sbrown: false,
            swhite:false,
            sred:false,
            syellow:false,
            sblue:false,
            sgreen:false,
            srainbow:false,
            sorange: false,
        }
    },
    components: {
        'datepicker': Datepicker,
    },
    created(){  
        firebase.auth().onAuthStateChanged(user => {
            if (user){
                this.requested = firebase.auth().currentUser.uid
                console.log(this.requested)
                this.fetchListings()
            }
        })
        
    },
    methods: {
        cfront(olist){
            const docid = olist.document_Id
            const fullname = olist.fullname
            const img = olist.mainURL
            const cFRONT = this.$router.resolve({path: 'cfront/', query:{docid:docid, fullname:fullname, img:img}
            });
            window.open(cFRONT.href, '_blank')
        },
        addColor(color){
            this.colorfamily.push(color)
            
            if (color == 'brown'){
                this.sbrown = true
            } else if (color == 'blue'){
                this.sblue = true
            } else if (color == 'green'){
                this.sgreen = true
            } else if (color == 'yellow'){
                this.syellow = true
            } else if (color == 'red'){
                this.sred = true
            } else if (color == 'orange'){
                this.sorange = true
            } else if (color == 'white'){
                this.swhite = true
            } else if (color == 'rainbow'){
                this.srainbow = true
            } else if (color == 'black'){
                this.sblack = true
            }
        },
        uploadPics(olist){
            const input = this.$refs.fileInput;
            const files = input.files;
            if (files && files[0]){
                resizeImage({
                    file: files[0],
                    sizes: [600]
                }).then(({blobs}) => {
                    this.accentBlob = blobs[0]
                    const fileref = "imgAccent_" + olist.artmarketID + ".png";

                    if (this.accentBlob !== undefined){
                        const storageRef = firebase.storage().ref().child('artmarketIMG').child(fileref).put(this.accentBlob);
                        storageRef.on(`state_changed`, snapshot => {
                            this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        }, error => {
                            alert(error.message);
                        }, () => {
                            this.uploadValue = 100;
                            storageRef.snapshot.ref.getDownloadURL().then(imgaccent => {
                                this.fsaccent = imgaccent

                                const input2 = this.$refs.fileInput2;
                                const files2 = input2.files;
                                if(files2 && files2[0]){
                                    resizeImage({
                                        file:files2[0],
                                        sizes:[800]
                                    }).then(({blobs}) => {
                                        this.accentBlobW = blobs[0]
                                        const fileref2 = "imgAccentW_" + olist.artmarketID + ".png";
                                        if (this.accentBlobW !== undefined){
                                            const storageRef = firebase.storage().ref().child('artmarketIMG').child(fileref2).put(this.accentBlobW);
                                            storageRef.on(`state_changed`, snapshot => {
                                                this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                                            }, error => {
                                                alert(error.message);
                                            }, () => {
                                                this.uploadValue = 100;
                                                storageRef.snapshot.ref.getDownloadURL().then(imgaccentW => {
                                                    this.fsaccentW = imgaccentW

                                                    if (this.fsaccentW !== "" || this.fsaccent !== ""){
                                                        const updateimgdata = ({
                                                            imgAccent: this.fsaccent,
                                                            imgAccentW: this.fsaccentW,
                                                            artmarketID: olist.artmarketID
                                                        })
                                                        const uploadAccents = firebase.functions().httpsCallable('accentIMG')
                                                        uploadAccents(updateimgdata).then(result => {
                                                            if (result){
                                                                this.isUploaded = true
                                                            }
                                                        })
                                                    }
                                                })
                                            })
                                        }
                                    })
                                }
                            })
                        })
                    }
                })
            }
        },
        openImage(artworkimage){
        const openPost = artworkimage
        window.open(openPost, "_blank");
        },
        openLabel(label){
            const printlabel = label
            window.open(printlabel, "_blank");
        },
        completeDetails(olist){
            const colorarray = this.colorfamily.length
            if (colorarray < 1){
                console.log(colorarray, "OOOH")
                alert('choose colors')
                return
            }
           const crate = this.commissionRate
           const mcEarn = this.earnPercentage
           const artmarketID = olist.artmarketID
            const decimalcrate = crate / 100
            const decimalmcearn = mcEarn / 100
            const cdate = moment(this.dateSelect.date).unix()
            const nowis = parseInt(new Date()/1000)
            var expirationdate = ""
            if (nowis == cdate ||  nowis > cdate){
                expirationdate = 0
            } else {
                expirationdate = cdate
            }

            console.log(crate, mcEarn, artmarketID, "Decimals ===", decimalcrate, decimalmcearn, cdate )
            const updatedetails = ({
                colorfamily:this.colorfamily,
                commissionRate: decimalcrate,
                earnPercentage: decimalmcearn,
                cRateDate: expirationdate,
                artmarketID: artmarketID,
                listID: olist.listID,
                oID: olist.document_Id
            })
            console.log(updatedetails)
            const processDetails = firebase.functions().httpsCallable('listingProcessed')
            processDetails(updatedetails).then(result => {
                if (result){
                    console.log('Success updating Marketlisting')
               
            const oid = olist.document_Id
            db.collection('posts').doc(oid).get().then(async document => {
                if(document){
                    const data = document.data()
                    const metaIMG = data.metaIMG;
                    const artTitle = data.artTitle;
                    
                    const makelink = ({
                    metaimg: metaIMG,
                    artmarketID: olist.artmarketID,
                    artTitle: artTitle,
                    artist: olist.artistUsername || olist.username,
                    uid:olist.user_Id,
                    imgAccent: this.fsaccent
                    })

                    console.log(makelink)
                    
                    const marketlink = firebase.functions().httpsCallable('marketLink')
                    marketlink(makelink).then(result => {
                        if (result){
                            alert("Success")
                            console.log("success marketlink send function")
                        }
                    }).catch(err => {
                        alert(err, "oops")
                        console.log(err)
                    })
                }
            })
             }
            })
        },
        // processed(listID, list){
        //     const processedOrder = ({
        //         listID: listID
        //     })
        //     const sendprocessed = firebase.functions().httpsCallable('listingProcessed')
        //     sendprocessed(processedOrder).then(result => {
        //         if (result){
        //             console.log('order listing is processed')
        //         }
        //     })

        //     const oid = list.document_Id
        //     db.collection('posts').doc(oid).get().then(async document => {
        //         if(document){
        //             const data = document.data()
        //             const metaIMG = data.metaIMG;
        //             const artTitle = data.artTitle;

        //             const makelink = ({
        //             metaimg: metaIMG,
        //             artmarketID: list.artmarketID,
        //             artTitle: artTitle,
        //             artist: list.artistUsername
        //             })
                    
        //             const marketlink = firebase.functions().httpsCallable('marketLink')
        //             marketlink(makelink).then(result => {
        //                 if (result){
        //                     alert(result, "Success")
        //                     console.log("success marketlink send function")
        //                 }
        //             }).catch(err => {
        //                 alert(err, "oops")
        //                 console.log(err)
        //             })
        //         }
        //     })
        // },
        async fetchListings(){
            const getListings = firebase.functions().httpsCallable('fetchListings')
            var result = await getListings({uid:this.requested})
            console.log('resuu==>>>', result);
            try {
                    this.sortdoc = result.data;
                    this.sortdoc = _.sortBy(this.sortdoc, i => i.serverTime).reverse()
                    this.ldoc = this.sortdoc
            } catch(err) {
                console.log(err, 'could not fetch results')
            }
        },
        viewPost(postid){
         const openPost = "https://artmuseo.com/art/?artworkID=" + postid
            console.log(openPost, "This is the url link")
            window.open(openPost, "_blank");
        },
        openListing(list){
            this.olist = {}
            this.olist = list
            this.colorfamily = []
            this.commissionRate = ""
            this.cRateDate = ""
            this.earnPercentage = ""
            this.syellow = false
            this.sblack = false
            this.sbrown = false
            this.swhite = false
            this.sred = false
            this.sorange = false
            this.sblue = false
            this.sgreen = false
            this.srainbow = false
            this.isUploaded = false
            this.fsaccent = ""
            this.fsaccentW = ""
        },
    }
}
</script>

<style scoped>
#mainhold {
    width: 100%;
    height: 65vh;
    background-color: white;
    position: relative;
    overflow: scroll;
    position: relative;
}

.colorBox {
    width: 40px;
    height: 40px;
    margin-right: 5px;
    float: left;
    clear: right;
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
}

.selectedColor {
    width: 30px;
    height: 30px;
    margin-right: 5px;
    float: left;
    clear: right;
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
    border-width: 2px;
    border-color: black;
    border-style: solid;
    border-radius: 15px;
}

.holder {
    width: auto;
    height: auto;
    margin-top: 10px;
    margin-bottom: 5px;
    margin-left: 20px;
    float: left;
    clear: right;
    /* background-color: aquamarine; */
}

.overAll {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: white;
}

.buttonHolder {
    width: 100px;
    height: auto;
    position: absolute;
    top: 0;
    margin-top: 140px;
    right: 0;
    margin-right: 20px;
}

.imgHolder2 {
    width: 100px;
    height: 100px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    float: left;
    clear: right;
    position: absolute;
    top: 0;
    right: 0;
    margin-top: 20px;
    margin-right: 20px;
}

.cpointer {
    cursor: pointer;
}

.btn {
    width: auto;
    height: auto;
    padding: 2%;
    border-radius: 2vmin;
    text-align: center;
    color: white;
    float:left;
    clear: right;
}

.inputbar {
    width: 100%;
    height: auto;
    float: left;
    clear: right;
}

.btn2 {
    width: 150px;
    height: auto;
    padding: 2%;
    border-radius: 2vmin;
    text-align: center;
    color: white;
    float: left;
    clear: right;
    margin-bottom: 4px;
}

#leftcol {
    width: 40%;
    height: auto;
    float: left;
    clear: right;
    position: relative;
    border-right-color: #00a89d;
    border-right-width: 2px;
    border-right-style: solid;
}

.spacer {
    width: 100%;
    height: 20px;
    float: left;
    clear: both;
}


#rightcol {
    width: 50%;
    height: auto;
    position: sticky;
    top: 0;
    padding-top:10px;
    margin-top: 10px;
    right: 0;
    margin-right: 0vw;
    margin-left:20px;
    float: left;
}

.imgHolder {
    width: 50px;
    height: 50px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    float: left;
    clear: right;
}

.wrapper {
    width: 60%;
    float: left;
    clear: right;
    height: auto;
    text-align: right;
    margin-left: 20px;
}

.wrapperr {
    width: 60%;
    float: left;
    clear: right;
    height: auto;
    text-align: left;
    margin-left: 20px;
}

.listingholder {
    width: 100%;
    height: auto;
    float: left;
    clear: right;
    padding: 2%;
    margin-bottom: 5px;
}

.cols {
    width: 50%;
    height: auto;
    float: left;
    clear: right;
    padding: 5%;
    border-right-color: #00a89d;
    border-right-width: 2px;
    overflow: scroll;
}
</style>